import { Grid, Theme, useMediaQuery } from '@mui/material';
import { ProfileIcon, SupportIcon } from 'assets/Icons';
import { CustomTab, CustomTabs, Faqs, TabPanel, a11yProps } from 'components/molecules';
import renderIcon from 'icon';
import React, { useState } from 'react';
import { IoArrowBackCircleSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { HeaderCON } from '../styles';

export const Support = () => {
  const navigate = useNavigate();
  const [currentRoute, setCurrentRoute] = useState(0);
  const lg = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  const handleChange = (_: React.SyntheticEvent<Element, Event>, value: any) => {
    setCurrentRoute(value);
  };
  return (
    <>
      <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
        {renderIcon(IoArrowBackCircleSharp, {
          size: 24,
          className: 'text-black flex-shrink-0 cursor-pointer hover:text-gray-600 transition-colors',
          onClick: () => navigate('/account')
        })}
        <span
          className="font-semibold"
          style={{ color: '#222', cursor: 'pointer' }}
          onClick={() => navigate('/account')}>
          Account
        </span>
        <span>›</span>
        <span className="font-semibold" style={{ color: '#222' }}>
          Support
        </span>
      </div>
      {!lg && <HeaderCON>Support</HeaderCON>}
      <Grid container gap={'35px'}>
        <Grid xs={12} lg={3.5} item>
          <CustomTabs
            value={currentRoute}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            orientation={lg ? 'horizontal' : 'vertical'}>
            <CustomTab label="FAQs" {...a11yProps(0)} disableRipple icon={<ProfileIcon />} iconPosition="start" />
            <CustomTab
              label="Customer Support"
              {...a11yProps(1)}
              disableRipple
              icon={<SupportIcon />}
              iconPosition="start"
            />
          </CustomTabs>
        </Grid>
        <Grid xs={12} md item>
          <TabPanel value={currentRoute} index={0}>
            <Faqs />
          </TabPanel>
          <TabPanel value={currentRoute} index={1}>
            <div className="bg-white rounded-lg p-6">
              <h2 className="font-semibold text-lg mb-2">Contact support</h2>
              <p className="text-gray-600 mb-3">In-app support tickets are not available yet.</p>
              <a className="text-primary underline" href="mailto:support@madina.ng">
                support@madina.ng
              </a>
            </div>
          </TabPanel>
        </Grid>
      </Grid>
    </>
  );
};
